import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHandTypes, ShowerHeadTypes} from "../../constants";

export default class WallUnion extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wall_union';
    this.partName = 'Wall Union';
    this.translateId = "visualizer.bathroom.shower.wall_union";
    this.canBeDisabled = true;
    this.useMatchingFeatureReplacement = "MountPosition";
    if (isChild) {
      createParentPositions(this);
    }
  }
  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    if (showerParent.shower_hand_type === ShowerHandTypes.hand_shower_kit) {
      if (showerParent.handShowerKit && showerParent.handShowerKit.activeFeature && showerParent.handShowerKit.activeFeature.metaData["MountPosition"]) {
        conditions.push({
          propName: "MountPosition",
          propValue: ["3"]
        })
      }
    } else if (showerParent.shower_hand_type === ShowerHandTypes.hand_shower_holder) {
      if (showerParent.handShowerHolder && showerParent.handShowerHolder.activeFeature) {
        conditions.push({
          propName: "MountPosition",
          propValue: showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
            ? showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
            : ["2"]
        })
      }
    }

    return conditions
  }

}
